#import '../fragments/account-plan-fragment.graphql'

mutation UpdatePlanSelection($input: PlanSelectionUpdateInput!) {
    planSelectionUpdate(input: $input) {
        accountBilling {
            currentPlan {
                ...AccountPlanFragment
            }
        }
    }
}
